import { render, staticRenderFns } from "./StatisticsSystemStatusCurrencies.vue?vue&type=template&id=31688f3b&scoped=true&"
import script from "./StatisticsSystemStatusCurrencies.vue?vue&type=script&lang=js&"
export * from "./StatisticsSystemStatusCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsSystemStatusCurrencies.vue?vue&type=style&index=0&id=31688f3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31688f3b",
  null
  
)

export default component.exports